module.exports = __webpack_public_path__ + "img/4.242f6445.jpg";